import React, { useState, Fragment } from 'react'
import { Card } from '@mui/material'
import { Button } from '../../Common/ui/button'
import * as RoutePaths from '../../Entities/RoutePath'
import { AiFillExclamationCircle } from 'react-icons/ai'
import useCustomNavigate from '../../Common/ui/Navigate'

const HeatMapSelector = () => {
    const [ selectedMap, setSelectedMap ] = useState('')
    const handleSelect = (mapType) => {
        setSelectedMap(mapType)
    }
    const customNavigate = useCustomNavigate()

    const handleHeatMapAbout = () => {
        customNavigate(RoutePaths.MAIN_CONTAINER.MAIN + RoutePaths.SETTINGS.URI + RoutePaths.HEAT_MAP_ABOUT.URI, <div>About Heat Map</div>)
    }
    const handleCancel = () => {
        // Implement cancel logic here
    }

    const handleSubmit = () => {
        // Implement submit logic here
    }

    return (
        <Fragment>
            <div className='w-[95%] m-3'>
                <div className="header-container flex justify-between items-center m-3">
                    <h2 className='font-semibold  text-muted'>Choose the preferable Heat map</h2>
                    <div className="flex items-center cursor-pointer">
                        <div> <AiFillExclamationCircle className="mr-1  text-primary mt-5"style={{ width: '28.33px', height: '28.33px' }} /></div>
                        <p className='pt-5 pr-10 text-muted font-medium' onClick={handleHeatMapAbout}>About</p>
                    </div>
                </div>
                <div>
                    <div className="card-container gap-2 flex flex-column justify-evenly items-center">
                        <div className={`heatmap-card ${selectedMap === '3x3' ? 'selectedCardofHeatMap' : ''}`} >
                            <label htmlFor="3x3">
                                <Card className='p-2 border-2 heatmap-card-content' style={{
                                    border: selectedMap === '3x3' ? '2px solid #007876' : '2px solid transparent',
                                    background: selectedMap === '3x3' ? '#B2D9D84D' : 'transparent'
                                }}>
                                    <input
                                        className='radio-input position-absolute top-0 end-0 mt-2 me-2 '
                                        type="radio"
                                        id="3x3"
                                        name="heatmap"
                                        value="3x3"
                                        checked={selectedMap === '3x3'}
                                        onChange={() => handleSelect('3x3')} />
                                    <img src={'/Common/Icon/heatmap3x3Full.svg'} alt="3x3 Heat map" />
                                </Card>
                            </label>
                            <h3 className='font-medium text-muted text-center mt-2'>3x3 Heat map</h3>
                        </div>

                        <div className={`heatmap-card ${selectedMap === '5x5' ? 'selectedCardofHeatMap' : ''}`} >
                            <label htmlFor="5x5">
                                <Card className='p-5 border-2 heatmap-card-content' style={{
                                    border: selectedMap === '5x5' ? '2px solid #007876' : '2px solid transparent',
                                    background: selectedMap === '5x5' ? '#B2D9D84D' : 'transparent'
                                }}>
                                    <input
                                        className='radio-input position-absolute top-0 end-0 mt-2 me-2 '
                                        type="radio"
                                        id="5x5"
                                        name="heatmap"
                                        value="5x5"
                                        checked={selectedMap === '5x5'}
                                        onChange={() => handleSelect('5x5')} />
                                    <img src={'/Common/Icon/heatmap5x5Full.svg'} alt="5x5 Heat map" />
                                </Card>
                            </label>
                            <h3 className='font-medium text-muted text-center mt-2'>5x5 Heat map</h3>
                        </div>
                    </div>
                </div>
                <div className="button-container flex justify-end mt-4">
                    <Button variant="outline" onClick={handleCancel} className='m-3'>Cancel</Button>
                    <Button variant="default" onClick={handleSubmit} className='m-3'>Submit</Button>
                </div>
            </div>
        </Fragment>
    )
}

export default HeatMapSelector
